// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_report_condition_properties.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { CBCT_Tooth_RootType } from "./dto_report_common_pb.js";

/**
 * //////////////////////////////////////////////////////////////
 * //  Condition property.
 * //
 * //  Additional properties, which can be presented for some
 * //  of the conditions. For each condition the properties
 * //  may vary.
 * //
 *
 * @generated from message com.diagnocat.model.ConditionProperty
 */
export const ConditionProperty = proto3.makeMessageType(
  "com.diagnocat.model.ConditionProperty",
  () => [
    { no: 1, name: "PeriapicalRadiolucency", kind: "message", T: PeriapicalRadiolucencyProperty, oneof: "Content" },
  ],
);

/**
 * @generated from message com.diagnocat.model.PeriapicalRadiolucencyProperty
 */
export const PeriapicalRadiolucencyProperty = proto3.makeMessageType(
  "com.diagnocat.model.PeriapicalRadiolucencyProperty",
  () => [
    { no: 1, name: "LesionVolume", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "AffectedRootType", kind: "enum", T: proto3.getEnumType(CBCT_Tooth_RootType) },
  ],
);

